module.exports = __webpack_public_path__ + "static/testing-1-b178218c7ceb8696d67c7f61745837ab.png";